import { Directive, Input } from '@angular/core';

import { ValueAccessorBase } from '~/component/value-accessor.base';
import { generateUid } from '~/core/helpers/uid/uid.helper';

@Directive()
export abstract class FormControlChildAbstract<T> extends ValueAccessorBase<T> {
  @Input() public disabled = false;
  @Input() public hasError = false;
  @Input() public id? = generateUid();
  @Input() public required = false;
  @Input() public tabindex = 0;

  public get errorsId(): string {
    return this.hasError ? `errors-${this.id}` : null;
  }
}
